module.exports = __webpack_public_path__ + "static/media/logo.65d7a4c0.png";